



















import { Component, Vue } from 'vue-property-decorator'
import { DefaultServerResponse } from '@/components/ui/TechTaskCard.vue'
import requests from '@/helpers/requests'


enum State {
    LOADING = 'loading',
    READY = 'ready',
    ERROR = 'error'
}


interface AuditDatum {
    techTaskName: string;
    total: number;
    success: number;
    error: number;
    successRate: number;
    errorRate: number;
}


interface ResponseData extends DefaultServerResponse {
    data: {
        techTasks: AuditDatum[];
    };
}


@Component
export default class InternalToolsStats extends Vue {
    State = State
    currentState = State.LOADING
    errorMessage: null|string = null
    techTasks: AuditDatum[] = []
    tableHeaders = [
        {
            text: 'Tool',
            value: 'techTaskName',
            sortable: false
            // align? : 'start' | 'center' | 'end',
            // sortable? : boolean,
            // filterable? : boolean,
            // groupable? : boolean,
            // divider? : boolean,
            // class? : string | string[],
            // width? : string | number,
            // filter? : (value: any, search: string, item: any) => boolean,
            // sort? : (a: any, b: any) => number
        },
        {
            text: 'Count',
            value: 'total',
            align: 'end'
        },
        {
            text: 'Success Rate',
            value: 'successRate',
            align: 'end'
        },
        {
            text: 'Error Rate',
            value: 'errorRate',
            align: 'end'
        }
    ]

    async mounted() {
        await this.load()
    }

    async load() {
        this.currentState = State.LOADING
        try {
            const response = await requests.post('/support/nerd/load-tech-task-audit') as ResponseData
            this.techTasks = response.data.techTasks
            this.currentState = State.READY
        } catch(e) {
            this.currentState = State.ERROR
            this.errorMessage = e.message
        }
    }
}
